import auth from './auth'
import tab from './tab'

export default {
  install(Vue) {
    // 认证对象
    Vue.prototype.$auth = auth
    // tab页签对象
    Vue.prototype.$tab = tab
  }
}